import React, { Fragment, useState, useEffect } from "react";

export default function CTA() {
  return (
    <div className="mt-5 mb-5 sm:mx-auto sm:text-center lg:text-left lg:mx-0 bg-indigo-200 rounded p-6">
      <p className="text-base font-medium text-gray-900">
        Want more Tailwind UI + React tools? Slap down your email and I'll let
        you know when there's a new one.
      </p>
      <form
        action="https://mail.gen.co/subscription/S1q9_P3tI"
        method="GET"
        className="mt-3 sm:flex"
      >
        <input
          aria-label="Email"
          className="appearance-none block w-full px-3 py-3 border border-gray-300 text-base leading-6 rounded-md placeholder-gray-500 shadow-sm focus:outline-none focus:placeholder-gray-400 focus:shadow-outline focus:border-blue-300 transition duration-150 ease-in-out sm:flex-1"
          placeholder="Enter your email"
          id="email"
          name="email"
        />
        <button
          type="submit"
          className="mt-3 w-full px-6 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-800 shadow-sm hover:bg-gray-700 focus:outline-none focus:shadow-outline active:bg-gray-900 transition duration-150 ease-in-out sm:mt-0 sm:ml-3 sm:flex-shrink-0 sm:inline-flex sm:items-center sm:w-auto"
        >
          Notify me
        </button>
      </form>
      {/*<p className="mt-3 text-sm leading-5 text-gray-500">
                We care about the protection of your data. Read our
                <a href="#" className="font-medium text-gray-900 underline">
                  Privacy Policy
                </a>
                .
              </p>*/}
    </div>
  );
}
